<template>
  <div :class="{ disabled: disabled, loading: isLoading }" class="footer">
    <div class="footer-body">
      <div v-if="!isLoading" class="title">
        <h3>{{ title }}</h3>
      </div>
      <div v-if="isLoading" class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    disabled: {
      type: Boolean,
      default: false
    },
    isLoading: Boolean
  },
  mounted() {
    this.$store.commit('components/setHasFooter', true)
  },
  beforeDestroy() {
    this.$store.commit('components/setHasFooter', false)
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

@footer-space: @space-m+ @space-xxs;
@footer-bg: @btn-proceed-bg;
@footer-text: @btn-proceed-text;

@footer-disabled-text: @btn-proceed-disabled-text;

@footer-loader-size: 36px;

.footer {
  -webkit-overflow-scrolling: touch;
  position: fixed;
  width: 100vw;
  bottom: 0px;
  left: 0;
  top: auto;
  z-index: 99999;
}

.footer-body {
  .lh-display(flex);
  .lh-align-items(flex-start);
  .shadow(0, -3px, 8px, 5, @grey-dark);
  height: @footer-height;
  padding-top: @footer-space;
  background-color: @footer-bg;

  > div {
    .lh-flex(1);
    .lh-display(flex);
    .lh-justify-content(center);

    &:first-child span {
      margin-right: auto;
    }
    &:last-child span {
      margin-left: auto;
    }
  }
}

.title {
  color: @footer-text;
  line-height: 18px;
  text-transform: uppercase;
}

.footer.disabled {
  .title {
    color: @footer-disabled-text;
  }
}

// Loader
.footer-body {
  .lds-ring {
    width: @footer-loader-size;
    height: @footer-loader-size;
    right: 10px;
    top: auto;
    bottom: auto;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 22px;
    height: 22px;
    margin: 6px;
    border: 3px solid @footer-text;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: @footer-text transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
